import { ReactNode } from "react";
import styles from "./styles.module.scss";
import AppFooter from "./AppFooter";
import { ROUTES, URL_SOURCE_TYPE } from "src/utils/enums";
import { checkPathMatch } from "src/utils/utils";
interface CustomLayoutProps {
  children: ReactNode;
}

export const CustomLayout = ({ children }: CustomLayoutProps) => {
  return (
    <div className={styles.layout}>
      <div className={styles.content}>
        {children}
      </div>
      { !checkPathMatch([URL_SOURCE_TYPE.ENSURE+"/" + ROUTES.ACTIVATE_CREDIT_CARD], ["success", "failure"]) && <AppFooter /> }
    </div>
  );
};